<template>
  <div id="meeting-planner">
    <table class="table pref-table">
      <thead>
        <tr>
          <td class="td-style" style="width: 5%"></td>
          <td class="td-style" style="width: 15%">Name</td>
          <td class="td-style" style="width: 25%">Job Title</td>
          <td class="td-style" style="width: 25%">Email</td>
          <td class="td-style" style="width: 15%">Mobile</td>
          <td class="td-style" style="width: 5%">Status</td>
          <td class="td-style" style="width: 10%"></td>
        </tr>
      </thead>
      <tbody class="group accordion-header">
        <tr v-for="(mate, index) in mates" :key="index">
          <td>
            <input
              type="checkbox"
              v-model="selected_presenters"
              :value="mate.id"
              :disabled="mate.status == 2"
              @change="pushDataToParent"
            />
          </td>
          <td class="text-start">{{ mate.client.full_titled_name }}</td>
          <td class="text-start">{{ mate.client.job_title }}</td>
          <td class="text-start">{{ mate.client.email }}</td>
          <td class="text-start">{{ mate.client.mobile }}</td>
          <td class="text-start">
            {{ mate.status == 1 ? "Not Registered" : mate.status_human }}
          </td>
          <td>
            <div class="d-flex">
              <RegisterModal
                :addMateData="addMateData"
                :mateData="mate"
                :updateMateData="updateMateData"
              ></RegisterModal>
              <button
                v-if="mate.status == 2"
                style="margin-right: 4px"
                @click="(e) => cancelPresenter(e, mate)"
              >
                Cancel
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import RegisterModal from "./registerMateModal.vue";
import VueSelect from "vue-select";
import { mapState } from "vuex";
import Api from "@/Api";

export default {
  name: "presenter-mate-table",
  props: ["mates", "mapSelectedMatesData", "updateMateData"],
  components: {
    Layout,
    VueSelect,
    RegisterModal,
  },
  data() {
    return {
      presenter_mates: [],
      selected_presenters: [],
      selected_presenters_data: [],
    };
  },
  methods: {
    addMateData(mateId, mateFormData, isValidData = true, errors = {}) {
      const exist = this.selected_presenters_data.filter(
        (mate) => mate.mateId === mateId
      );
      if (exist.length > 0) {
        this.selected_presenters_data = this.selected_presenters_data.map(
          (mate) => {
            if (mate.mateId === mateId) {
              return { mateId, mateFormData, valid: isValidData, errors };
            }
            return mate;
          }
        );
      } else {
        this.selected_presenters_data = [
          ...this.selected_presenters_data,
          { mateId, mateFormData, valid: isValidData, errors },
        ];
      }
      this.pushDataToParent();
    },
    pushDataToParent() {
      this.mapSelectedMatesData(
        this.selected_presenters,
        this.selected_presenters_data
      );
    },
    cancelPresenter(e, mate) {
      this.$swal({
        html: '<p style="color:red"> Are you sure you want to cancel your colleague’s registration ?</p>',
        toast: true,
        showCancelButton: true,
        confirmButtonText: "OK",
        position: "top",
        width: "45rem",
        customClass: {
          actions: "flex justify-end",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Api()
            .post("auth/update-presenter-status", { conf_client_id: mate.id })
            .then((res) => {
              mate.status = res.data.confClient.status;
              mate.status_human = res.data.confClient.status_human;
              this.updateMateData(mate);
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },
  },
  created() {
    this.presenter_mates = this.mates;
  },
  computed: {
    ...mapState(["registeringPresenterData"]),
  },
};
</script>

<style scoped>
.td-style {
  text-align: left;
  padding-left: 0px;
}

.d-flex {
  display: flex;
}

.text-start {
  text-align: left;
  padding-left: 0px;
}

.content-center {
  justify-content: center;
}
</style>
